import {
  IonButton,
  IonCard,
  IonContent,
  IonGrid,
  IonIcon,
  IonPage,
  IonSpinner,
  IonText,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import "../theme/Results.css";

import "../theme/Utilities.css";
import { useParams } from "react-router";
import { MeasurementResource, ObjectModel } from "../common/types";
import MeasurmentResult from "../components/MeasurementsResults";
import { AuthProvider, saveTask, getMeasurement } from "../pt/utils/http-service";
import { getConfigForExperience, KeyLabel } from "../common/domainConfig";
import { useAuth } from "../context/AuthContext";
import { arrowForwardOutline, saveOutline } from "ionicons/icons";
import { ClientDataHolder } from "../pt/dashboard/data/data";
import { SessionData } from "../pt/utils/schemas";
import { getSession } from "../pt/utils/http-service";
import { getMeasurementFromModel } from "../components/measure/measureCache";
import { calculateBodyFat } from "../pt/dashboard/data/calculate-bf";
import { MeasureData } from "../pt/utils/interfaces";
const ResultPage: React.FC = () => {
  //const auth = new AuthProvider(useAuth0().getAccessTokenSilently);
  const auth = new AuthProvider(
    () => Promise.resolve("fix-ugly-later"),
    undefined,
    undefined,
    undefined,
    true
  );

  const history = useHistory();
  const { profileID, sessionID, gender } = useParams<{
    profileID: string;
    sessionID: string;
    gender: string;
  }>();
  const [session, setSession] = useState<SessionData>();

  const [client] = useState<ClientDataHolder>(
    new ClientDataHolder(profileID, auth)
  );
  const getResource = client.getResourceFromSession;
  const [isFetched, setIsFetched] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState<string | null>(null);
  const [visibleMeasurements, setVisibleMeasurements] = useState<KeyLabel[]>(
    []
  );
  const [objectModel, setObjectModel] = useState<ObjectModel | undefined>();

  const [measurements, setMeasurements] = useState<MeasurementResource>({
    id: "",
    createdAt: "",
    height: 0,
    head: 0,
    neck: 0,
    chest: 0,
    waist: 0,
    buttocks: 0,
    leg_inner: 0,
    arm_outer: 0,
  });

  const fetchModel = async (): Promise<ObjectModel> => {
    const session: SessionData = await getSession(profileID, sessionID, auth);
    setSession(session);

    // Check if this session's measurement was already saved
    const existing = await getMeasurement(profileID, sessionID, auth);
    if (existing) {
      setIsSaved(true);
    }

    const displayConfig = getConfigForExperience(session.experience);
    return await getResource(sessionID, "model")
      .then((data) => {
        if (
          data["gender"] === "female" ||
          (data["gender"] && data["gender"]["value"] === "female")
        ) {
          setVisibleMeasurements(displayConfig.measurements.female);
        } else {
          setVisibleMeasurements(displayConfig.measurements.male);
        }
        return data;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchMeasurements = async (): Promise<MeasurementResource> => {
    const heightInput = await getResource(sessionID, "height_input").then(
      (res) => res.value
    );

    return await getResource(sessionID, "measurements")
      .then((data) => {
        const scale = (heightInput * 100) / data.height;
        [
          "height",
          "head",
          "neck",
          "chest",
          "waist",
          "buttocks",
          "leg_inner",
          "arm_outer",
          "arm_upper",
          "arm_circ",
          "leg_circ",
          "waist_female",
        ].forEach((key) => {
          data[key] = data[key] * scale;
        });
        data.scale = scale * 10;

        return data;
      })
      .catch((err) => {
        console.log(err);

        throw new Error(`Error fetching measurements: ${err}`);
      });
  };

  const saveModel = async () => {
    setIsSaving(true);
    setSaveError(null);
    try {
      const measureData: MeasureData = {
        ID: "",
        profileID: profileID,
        client: profileID,
        createdAt: session?.createdAt || new Date(),
        sessionID: sessionID,
        measurements: {
          head: measurements.head,
          neck: measurements.neck,
          waist: measurements.waist,
          waist_female: measurements.waist_female || 0,
          buttocks: measurements.buttocks,
          chest: measurements.chest,
          leg_inner: measurements.leg_inner,
          leg_circ: measurements.leg_circ || 0,
          arm_outer: measurements.arm_outer,
          arm_circ: measurements.arm_circ || 0,
          body_fat: measurements.body_fat || 0,
          height: measurements.height,
        },
      };
      await saveTask(profileID, sessionID, measureData, auth);
      setIsSaved(true);
    } catch (error) {
      console.error("Failed to save measurement", error);
      setSaveError(
        "Could not save this measurement. Please try again. If it keeps failing, contact support."
      );
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    // if new taskId, setIsfetched to false
    setIsFetched(false);
  }, [sessionID]);

  useEffect(() => {
    let fetching = false;
    if (!isFetched) {
      const interval = setInterval(async () => {
        if (!fetching) {
          fetching = true;
          try {
            const model = await fetchModel();
            const measure = await fetchMeasurements();
            clearInterval(interval);

            const res = await getMeasurementFromModel({
              obj: String(model.obj),
              sessionID: measure.sessionID || "",
            });
            const scale = measure.scale || 1;
            console.log("Scale:", scale);
            const waist_female = res.best.slice.hullLength * scale;
            measure.waist_female = waist_female;
            const body_fat = calculateBodyFat(
              { ...measure, waist_female: waist_female },
              gender === "female" ? "female" : "male",
              "cm"
            );
            measure.body_fat = Math.floor(body_fat);

            const finalModel = {
              ...model,
              measurements: measure,
            } as ObjectModel;
            finalModel.measurements = measure;
            console.log("Final Model Measurements:", finalModel.measurements);
            setObjectModel(finalModel);
            setMeasurements(measure);
            setIsFetched(true);
            fetching = false;
          } catch (error) {
            console.error("Error fetching model or measurements:", error);
          } finally {
            fetching = false;
          }
        }
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [isFetched]);

  return (
    <IonPage className="mt-8">
      {!isFetched || !objectModel ? (
        <IonContent>
          <div className="loadingIconText">
            <div className="loadingIcon">
              <IonSpinner name="lines-sharp"></IonSpinner>
            </div>
            <br></br>
            <br></br>
            <IonText className="loadingText">
              <h1>Please wait...</h1>
            </IonText>
          </div>
        </IonContent>
      ) : (
        isFetched &&
        objectModel &&
        objectModel.measurements && (
          <IonContent>
            <IonGrid className="resultContent">
              <MeasurmentResult
                objectModels={[objectModel]}
                activeModel={0}
                visibleMeasurements={visibleMeasurements}
              />
              <IonCard>
                <IonButton
                  disabled={isSaved || isSaving}
                  fill="outline"
                  color="success"
                  onClick={() => {
                    saveModel();
                  }}
                >
                  {isSaving ? "Saving..." : "Save"}
                  <IonIcon icon={saveOutline}></IonIcon>
                </IonButton>
                {saveError && <IonText color="danger">{saveError}</IonText>}
                {isSaved &&
                  session?.redirect && (
                    <IonButton
                      disabled={false}
                      fill="outline"
                      color="success"
                      ion-router-link={session?.redirect}
                      href={session?.redirect}
                    >
                      {session?.redirectLabel || "Continue"}
                      <IonIcon icon={arrowForwardOutline}></IonIcon>
                    </IonButton>
                  )}
                {isSaved && (
                    <IonButton
                      fill="outline"
                      color="success"
                      href={`/dashboard/${profileID}?show=avatar&cookie=1`}
                    >
                    View Dashboard
                      <IonIcon icon={arrowForwardOutline}></IonIcon>
                    </IonButton>
                  )}
              </IonCard>
            </IonGrid>
          </IonContent>
        )
      )}
    </IonPage>
  );
};

export default ResultPage;
